<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-10 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-01 09:40:38
-->

<template>
	<div class="mt-12">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="商品标题">
				<el-input v-model="formData['product_name']" placeholder="请输入"></el-input>
			</el-form-item>

			<el-form-item label="商品ID">
				<el-input v-model="formData['third_product_id']" placeholder="请输入"></el-input>
			</el-form-item>

			<el-form-item label="商家ID">
				<el-input v-model="formData['shop_id']" placeholder="请输入"></el-input>
			</el-form-item>

			<el-form-item label="报名状态">
				<el-select v-model="formData['audit_status']" clearable placeholder="请选择">
					<el-option
						:label="item.label"
						:value="item.value"
						v-for="(item, index) in auditStatusArr"
						:key="index"
					></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="类目">
				<category-select v-model="formData['cate_id']" placeholder="请选择" :platformId="PLATFORM_KS"></category-select>
			</el-form-item>

			<el-form-item label="推广者信息" prop="contact_user_type">
				<el-select v-model="formData.contact_user_type" clearable placeholder="请选择">
					<el-option
						:label="item.label"
						:value="item.value"
						v-for="(item, index) in contactUserTypeArr"
						:key="index"
					></el-option>
				</el-select>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" @click="onSubmit">筛选</el-button>

				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { ksMyActivityUpStateList } from '@/utils/newDataMap/shopManage';
import CategorySelect from '@/components/common/categorySelect';
export default {
	name: 'search',
	components: { CategorySelect },
	props: ['PLATFORM_KS'],
	data() {
		return {
			formData: {},
			labelWidth: '140px',
			tabName: '0',
			auditStatusArr: ksMyActivityUpStateList,
			contactUserTypeArr: [
				{ label: '全部', value: '0' },
				{ label: '团长', value: '1' },
				{ label: '团长 + 达人', value: '3' },
			],
		};
	},
	methods: {
		onClear() {
			this.formData = {};
			this.onSubmit();
		},
		onSubmit: throttle(function() {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>

<style lang="less" scoped></style>

